import { NAV } from "../Navbar/navbarTheme";
import { sectionTitleSpacingSx } from "../sectionHeaderStyles";

export const HOME_PAGE_MAX_WIDTH = 1480;

export const pageShellSx = {
  width: "100%",
  bgcolor: "#fff",
  pb: { xs: 5, md: 7 },
};

export const pageGutterSx = {
  width: "100%",
  px: { xs: 2, sm: 3, md: 4 },
};

export const pageContentSx = {
  maxWidth: HOME_PAGE_MAX_WIDTH,
  mx: "auto",
  width: "100%",
  boxSizing: "border-box",
  py: { xs: 3, md: 4 },
};

export const pageTitleSx = {
  color: NAV.navy,
  fontSize: { xs: "1.65rem", sm: "1.9rem", md: "2.25rem" },
  fontWeight: 800,
  ...sectionTitleSpacingSx,
  lineHeight: 1.25,
  mb: { xs: 2, md: 2.5 },
  textAlign: { xs: "left", md: "center" },
};

export const sectionHeadingSx = {
  color: NAV.ink,
  fontSize: { xs: "1.25rem", md: "1.5rem" },
  fontWeight: 700,
  lineHeight: 1.3,
  mb: { xs: 1.75, md: 2 },
};

export const sectionBodySx = {
  color: NAV.ink,
  fontSize: { xs: "0.9375rem", md: "1.0625rem" },
  lineHeight: 1.7,
  mb: 1.5,
};

export const listItemSx = {
  padding: 0,
  display: "list-item",
  pl: 2.5,
  mb: 0.5,
};

export const bulletListSx = {
  color: NAV.ink,
  mb: 0,
  pl: { xs: 2, sm: 2.5 },
  listStyleType: "disc",
};

export const tableHeaderCellSx = {
  fontWeight: 700,
  fontSize: { xs: "0.8125rem", sm: "0.9375rem" },
  color: NAV.navy,
  bgcolor: "#eef5fb",
  borderBottom: `1px solid ${NAV.line}`,
  py: { xs: 1.25, sm: 1.5 },
};

export const tableBodyCellSx = {
  fontSize: { xs: "0.8125rem", sm: "0.9375rem" },
  color: NAV.ink,
  py: { xs: 1, sm: 1.25 },
};
